// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAFVRxp7n374N-MQg2cjS_nEgpcmjmRvfY",
    authDomain: "kajjainternational.firebaseapp.com",
    projectId: "kajjainternational",
    storageBucket: "kajjainternational.firebasestorage.app",
    messagingSenderId: "284080423770",
    appId: "1:284080423770:web:3642e348200d213f432963",
    measurementId: "G-0JC0TY0TSW"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// ✅ ENABLE OFFLINE PERSISTENCE - Caches data locally, syncs when online
enableIndexedDbPersistence(db, {
    cacheSizeBytes: CACHE_SIZE_UNLIMITED  // Use unlimited cache size
})
.then(() => {
    console.log('✅ Firestore offline persistence enabled! Data will be cached locally.');
    console.log('   - App works offline');
    console.log('   - Writes queue when offline');
    console.log('   - Auto-syncs when internet returns');
})
.catch((err) => {
    if (err.code === 'failed-precondition') {
        console.warn('⚠️ Multiple tabs open - persistence enabled in first tab only');
    } else if (err.code === 'unimplemented') {
        console.warn('⚠️ Browser doesn\'t support offline persistence');
    } else {
        console.error('❌ Error enabling persistence:', err);
    }
});

export default app;